export default {
  mounted: (el, binding) => {
    setTimeout(() => {
      el.parentNode.removeChild(el)
    }, binding.value ?? 3000)
  }
}
